import React, { useEffect, useState } from "react";
import ColorInit from "../../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import Preloader from "../../helper/Preloader";
import HeaderTwo from "../../components/HeaderTwo";
import Breadcrumb from "../../components/Breadcrumb";
import FooterTwo from "../../components/FooterTwo";
import BottomFooter from "../../components/BottomFooter";
import UserGaurd from "../../helper/AuthGaurd";
import DashboardSidebar from "../../components/DashboardSidebar";
import { handleError } from "../../utils/functions";
import axiosInstance from "../../config/axios.config";
import { toast } from "react-toastify";
import ProductCard from "../../components/Refine/ProductCard";
import { useTranslation } from "react-i18next";

const Wishlist = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    const getData = async () => {
      try {
        setIsLoading(true);
        const { data } = await axiosInstance.get("/wishlist");
        if (!data.error) {
          setData(data.data);
        } else {
          toast.error(data.message);
        }
      } catch (error) {
        handleError(error);
      } finally {
        setIsLoading(false);
      }
    };
    getData();
  }, []);

  const removeFunction = (slug) => {
    setData((prev) => prev.filter((item) => item.slug !== slug));
  };

  return (
    <UserGaurd>
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader isLoading={isLoading} />

      {/* HeaderTwo */}
      <HeaderTwo category={true} />

      {/* Breadcrumb */}
      <Breadcrumb title={t("wishlist")} />

      <div className="container">
          <div className="row mt-40">
            {data.map((item) => (
              <ProductCard item={item} className="col-lg-3 col-sm-4 col-6" removeFunction={removeFunction} />
            ))}
          </div>
      </div>

      {/* FooterTwo */}
      <FooterTwo />

      {/* BottomFooter */}
      <BottomFooter />
    </UserGaurd>
  );
};

export default Wishlist;
